<template>
    <div class="investors-m">
        <p class="indent"><span class="strong">ALCOMET AD</span> è una società per azioni con un sistema di gestione a due livelli, che comprende il Consiglio di vigilanza e il Consiglio di gestione. I membri degli organi direttivi sono eletti con un mandato di 5 anni</p>
        <p class="indent">Il 12 giugno 2017, l'Assemblea generale degli azionisti ha nominato con mandato quinquennale il nuovo Consiglio di vigilanza così composto:</p>
        <ol class="investors-m-ol">
            <li class="investors-m-li">Fikret Ince </li>
            <li class="investors-m-li">Fikret Kuzucu</li>
            <li class="investors-m-li">Semih Korai</li>
            <li class="investors-m-li">Bekir Yudzhel</li>
            <li class="investors-m-li">Hristo Todorov Dechev</li>
            <li class="investors-m-li">Osman Kerem Kuzucu</li>
            <li class="investors-m-li">Branimir Mladenov Mladenov</li>
        </ol>
        <p class="indent">Dopo l’elezione del Consiglio di vigilanza, lo stesso con protocollo N 77 nella sua riunione ha rinnovato con mandato quinquennale il Consiglio di gestione così composto:</p>
        <ol class="investors-m-ol">
            <li class="investors-m-li">Huseyin Yorucu</li>
            <li class="investors-m-li">Huseyin Umut Ince</li>
            <li class="investors-m-li">Semih Baturay</li>
            <li class="investors-m-li">Neli Kancheva Toncheva</li>
            <li class="investors-m-li">Bulent Karakoc</li>
            <li class="investors-m-li">Mehmet Emrah Sazak</li>
        </ol>
        <p class="indent">La politica di Corporate Governance della Società garantisce:</p>
        <ol class="investors-m-ol">
            <li class="investors-m-li">Tutela dei diritti dei principali azionisti;</li>
            <li class="investors-m-li">Parità di trattamento di tutti gli azionisti, compresi gli azionisti di minoranza e non residenti;</li>
            <li class="investors-m-li">Tutela dei diritti degli stakeholder e promozione di un'efficace cooperazione tra l'azienda e i suoi stakeholder per garantire benessere, posti di lavoro aperti e garantire uno sviluppo sostenibile;</li>
            <li class="investors-m-li">Divulgazione puntuale e accurata di informazioni su tutte le questioni relative alla Società, compresa la sua situazione finanziaria, le performance, la proprietà e le operazioni di produzione;</li>
            <li class="investors-m-li">Governance societaria strategica, controllo efficace delle attività del Consiglio di Gestione e la sua responsabilità verso il  Consiglio di vigilanza, la Società e gli azionisti.</li>
        </ol>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.investors-m p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.investors-m-ol {
  margin: 15px auto;
  list-style: decimal;
  padding-left: 20px;
  width: 60%;
}
.investors-m-li {
  display: list-item;
  font-size: 19px;
  line-height: 32px;
}
@media screen and (max-width: 1000px) {
  .investors-m > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .investors-m-ol {
    width: 100%;
    padding: 0 30px 0 50px;
  }
  .investors-m-li {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investors/Management.vue